export enum InvoiceTransitType {
    Import = 'import',
    Export = 'export',
}
